'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-media.min.js');
} else {
  module.exports = require('./cjs/react-media.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/react-media/index.js
// module id = 101
// module chunks = 59819425949494 221427640695397